/** @jsx jsx */
import { jsx } from 'theme-ui'
import Grid from '../helpers/grid'
import {
  AwardLabel,
  CupIcon,
  PeopleIcon,
  DatabaseIcon,
  WINNERS_CONFIG
} from './moreInfoConfig'
import WinnersCard from './winnersCard'
import MoreWinnersCard from './moreWinnersCard'

export const PUBLIC_CHOICE = () => (
  <AwardLabel icon={PeopleIcon} title="Public choice" bgColor="#50F094" />
)

export const JUDGES_CHOICE = () => (
  <AwardLabel icon={CupIcon} title="Judges' choice" bgColor="#79C3FF" />
)

export const OPENSIGNAL_CHOICE = () => (
  <AwardLabel icon={DatabaseIcon} title="Opensignal data" bgColor="#FF869C" />
)
const BroadbandTvSection = ({ children }) => (
  <div>
    <div sx={{ textAlign: 'center' }}>
      <h1
        sx={{
          fontSize: '36px',
          marginBottom: [32, 48],
          marginTop: ['48px', '64px']
        }}
      >
        Top broadband awards
      </h1>
    </div>
    <Grid gridTemplateColumns={'1fr'} gap={[32, 48]}>
      {[WINNERS_CONFIG.bestProviderBB, WINNERS_CONFIG.bestAlternativeBB].map(
        (award) => (
          <WinnersCard
            key={award.awardTitle}
            awardLabel={award.awardLabel}
            awardTitle={award.awardTitle}
            providerName={award.providerName}
            winnersLogo={award.winnersLogoCard}
            modalContent={award}
            ctaHref={award.providerLink}
            ctaText={award.ctaTitle}
          />
        )
      )}
    </Grid>

    <div sx={{ textAlign: 'center', mt: 72 }}>
      <h1 sx={{ mb: 64, fontSize: ['28px', '32px'] }}>More Broadband and TV</h1>
      <Grid
        gridTemplateColumns={[
          'repeat(2, minmax(0, 1fr))',
          'repeat(2, minmax(0, 1fr))',
          'repeat(3, minmax(0, 1fr))'
        ]}
        gap={['8px', '32px']}
      >
        {[
          WINNERS_CONFIG.mostPopularBB,
          WINNERS_CONFIG.bestProviderCS,
          WINNERS_CONFIG.mostReliableBB,
          WINNERS_CONFIG.bestValueForMoneyBB,
          WINNERS_CONFIG.bestBundleProvider,
          WINNERS_CONFIG.bestTVContent
        ].map((award) => (
          <MoreWinnersCard
            key={award.awardTitle}
            awardLabel={award.awardLabel}
            awardTitle={award.awardTitle}
            awardSubtitle={award.awardSubtitle}
            providerName={award.providerName}
            winnersLogo={award.moreWinnersLogoCard}
            modalContent={award}
            ctaHref={award.providerLink}
            ctaText={award.ctaTitle}
            ctaTextMobile={award.ctaTitleMobile}
          />
        ))}
      </Grid>
    </div>
  </div>
)

export default BroadbandTvSection
